import { ThemeUICSSObject, focusOutline, spacing } from '@apia/theme';

const collapsiblePanel: ThemeUICSSObject = {
  '.collapsiblePanel__label': {
    display: 'flex',
    gap: spacing(4),
    p: '1px',
    alignItems: 'center',
    justifyContent: 'space-between',

    '.collapsiblePanel__label__button': {
      display: 'flex',
      gap: spacing(4),
      p: '1px',
      alignItems: 'center',
      '&:focus': focusOutline,
      color: 'palette.text.primary',
    },
  },
};

export default collapsiblePanel;
